import React, { useState, useEffect, useRef } from "react";
import { Modal, Button, Form, Select, Input } from "antd";
import { API } from "../../config/config";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import CreditDocumentUploadField from "./CreditDocumentUploadField";
import UPLOAD_SUCCESS_DURATION_MS from "../../helper/UploadSuccessDuration";

const DATA_URL = "/requestcredit/";
const DATA_ALERT_URL = "/alert/";

const delay = ms => new Promise(
    resolve => setTimeout(resolve, ms)
);

const RequestCredit = (props) => {
    const { t, row, alertid, setIsRefresh, setActiveTabKey } = props;
    const [data, setData] = useState(false);
    const [isValidAlertID, setIsValidAlertID] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const uploadRef = useRef();
    const [isLoadingButton, setIsLoadingButton] = useState(false);
    const [isDisabledOkButton, setIsDisabledOkButton] = useState(true);

    const [form] = Form.useForm();

    const creditReasons = [
        {reason: "chargeback", value: "chargeback received after alert"},
        {reason: "duplicate", value: "duplicate"}
    ];

    const formItemLayout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const formValInit = () => {
        setIsValidAlertID(false);
        if (uploadRef.current) uploadRef.current.reset();
        setData({ alertid: alertid, reason_option: 'duplicate',credit_reason: 'duplicate', duplicate_alertid: "", comment: "", document: {} });
        form.setFieldsValue({ alertid: alertid, reason_option: 'duplicate', credit_reason: 'duplicate', duplicate_alertid: "", comment: "", document: {} });
    };

    const showModal = () => {
        setIsModalVisible(true);
        formValInit();
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const isAlertIdExist = async (id) => {
        const apiUrl = DATA_ALERT_URL + id;
        setIsLoadingButton(true);
        if (!id) {
            setIsLoadingButton(false);
            return false;
        }
        try {
            return await axios
                .get(API + apiUrl, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
                .then(({ data }) => {
                    if(data.parent[0])
                    {
                        return true;
                    }else{
                        return false;
                    }
                })
                .catch((err) => {
                    setIsLoadingButton(false);
                    return false;
                });
        } catch (error) {
            setIsLoadingButton(false);
            return false;
        }
    };

    

    const handleOk = async () => {
        // if (data.reason_option === "chargeback received after alert" && (!uploadRef.current || !uploadRef.current.hasFiles())) {
        //     const result = await Swal.fire({
        //         title: t("contents.alerts.no_document_warning_title") || "No documents uploaded",
        //         text: t("contents.alerts.no_document_warning") || "Alerts without an uploaded supporting document will not be submitted for credit review",
        //         icon: "warning",
        //         showCancelButton: true,
        //         confirmButtonColor: "#3085d6",
        //         cancelButtonColor: "#d33",
        //         confirmButtonText: t("login.continue") || "Continue",
        //         reverseButtons: true,
        //     });
        //     if (!result.isConfirmed) return;
        // }
        setIsLoadingButton(true);
        await delay(2000);
        if (data.reason_option !== "duplicate") {
            delete data.duplicate_alertid;
        }

        axios
            .post(API + DATA_URL, { ...data }, { headers: { Authorization: "Bearer " + Cookies.get("access_token") } })
            .then(async ({ data: respData }) => {
                if (respData.status === "OK") {
                    let uploadOk = true;
                    let docCount = 0;
                    if (uploadRef.current && uploadRef.current.hasFiles()) {
                        docCount = uploadRef.current.getFiles().length;
                        uploadOk = await uploadRef.current.uploadDocuments();
                    }
                    setIsModalVisible(false);
                    if (uploadOk) {
                        const docText = docCount > 0 ? t("contents.alerts.documents_uploaded_total", { total: docCount }) || `Documents uploaded: ${docCount}` : "";
                        Swal.fire({
                            icon: "success",
                            title: "Request credit successful",
                            text: [respData.msg, docText].filter(Boolean).join(". "),
                            showConfirmButton: false,
                            timer: docCount > 0 ? UPLOAD_SUCCESS_DURATION_MS : 2000,
                            timerProgressBar: docCount > 0,
                            onClose: () => {
                                setIsRefresh(moment().unix());
                                if (setActiveTabKey) {
                                    setActiveTabKey("alertCredits");
                                }
                            },
                        });
                    } else {
                        setIsRefresh(moment().unix());
                        if (setActiveTabKey) {
                            setActiveTabKey("alertCredits");
                        }
                    }
                } else {
                    Swal.fire({
                        icon: "error",
                        title: respData.msg,
                        showConfirmButton: true,
                    });
                }
                setIsLoadingButton(false);
            })
            .catch((error) => {
                const msg = error?.response?.data?.error_msg || error.message || "Unknown error";
                Swal.fire({
                    icon: "error",
                    title: msg,
                    showConfirmButton: true,
                });
                setIsLoadingButton(false);
            });
    };

    const formValChange = (chgV, allV) => {
        // setData(allV);

        // if (chgV.credit_reason === "chargeback") {
        //     setIsModalReminderVisible(true);
        // }
        const filtered = creditReasons.filter(v =>  v.value === allV.reason_option);
        setData({...data, reason_option: allV.reason_option, credit_reason: filtered[0].reason, comment: filtered[0].value + (allV.comment !== '' ? '. '+allV.comment : ''), duplicate_alertid:allV.duplicate_alertid  });
      
        if (
            chgV?.reason_option &&
            [
                "chargeback received after alert"
            ].includes(chgV.reason_option)
        ) {
            setIsDisabledOkButton(false);
        } else if ([
            "chargeback received after alert"
        ].includes(allV.reason_option))
        {
            setIsDisabledOkButton(false);
        }
        else
        {
          setIsDisabledOkButton(true);
        }
        


    };

    useEffect(() => {
        
        setIsDisabledOkButton(!isValidAlertID);
        if(!isValidAlertID)            
            {
                setData({...data, duplicate_alertid:""});
            }
     }, [isValidAlertID]); // eslint-disable-line react-hooks/exhaustive-deps


 

    const getReasonOptions = (row) => {
        return creditReasons.map((reason) => (
            <Select.Option key={reason.value} value={reason.value} hidden={(row.reasoncode !== null && row.reasoncode.match(".002") && reason.reason === 'chargeback')} className="text-capital">
                {reason.value}
            </Select.Option>
        ));
    };

    return (
        <>
            <Button disabled={props.disabled} onClick={showModal} style={{ marginRight: "0.5rem" }}>
                {t("contents.alerts.request_credit")}
            </Button>
            <Modal
                title={t("contents.alerts.request_credit")}
                visible={isModalVisible}
                width={560}
                onOk={handleOk}
                onCancel={handleCancel}
                footer={[
                    <Button key="back" size="default" onClick={() => handleCancel()}>
                        {t("contents.chargebacks.form.cancel")}
                    </Button>,
                    <Button key="submit" size="default" type="primary" onClick={() => handleOk()} disabled={isDisabledOkButton} loading={isLoadingButton}>
                        {t("tables.actions.ok")}
                    </Button>,
                ]}
            >
                <Form size="default" {...formItemLayout} form={form} onValuesChange={formValChange}>
                    <Form.Item label={t("contents.alerts.alert_id")} className="mb-075">
                        <span className="ant-form-text">{alertid}</span>
                    </Form.Item>
                    <Form.Item name="alertid" hidden={true}>
                        <Input />
                    </Form.Item>
                    <Form.Item label={t("contents.alerts.credit_reason")} name="reason_option" className="mb-075">
                        <Select className="text-capital" >
                            {getReasonOptions(row)}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        hasFeedback
                        name="duplicate_alertid"
                        label={t("contents.alerts.duplicate_alertid")}
                        className="mb-075"
                        hidden={data && data.reason_option !== "duplicate"}
                        validateTrigger="onBlur"
                        rules={[
                            ({ getFieldValue }) => ({
                                async validator(_, value) {
                                    try {
                                        if (!value) {
                                            throw new Error("Please enter duplicate alert ID.");
                                        } else{
                                            const valid = await isAlertIdExist(value);
                                            
                                            if (!valid) {
                                                throw new Error(t("contents.alerts.required_messages.duplicate_alertid_not_valid")+value);
                                            }else if (parseInt(value) === parseInt(data.alertid)) {
                                                throw new Error("Duplicate Alert ID couldn't be the same as Alert ID" +value);
                                            }
                                        }
                                    } catch (error) {
                                        setIsValidAlertID(false);
                                        setIsLoadingButton(false);
                                        return Promise.reject(error.message);
                                    }
                                    setIsValidAlertID(true);
                                    setIsLoadingButton(false);
                                    return Promise.resolve();
                                },
                            }),
                        ]}
                    > 
                  
                        <Input  type="number"/>
                    </Form.Item>
                    <Form.Item name="comment" label={t("contents.alerts.comment")} className="mb-075">
                        <Input.TextArea rows={2} />
                    </Form.Item>
                    <CreditDocumentUploadField
                        ref={uploadRef}
                        t={t}
                        alertId={alertid}
                        className="mb-075"
                        label={t("contents.alerts.upload_credit_documents") || "Upload Credit Documents"}
                    />
                </Form>
            </Modal>

        </>
    );
};

export default RequestCredit;
